import { z } from "zod";

/**
 * Shared socket shapes for the pricelist-case reminder steps. Defined once so
 * the `query_due_pricelist_case_follow_ups` output element stays identical to
 * the `prepare_pricelist_case_reminder` input and the fan-out edge type-checks
 * — the same arrangement the AR collection-reminder steps use.
 */
export const pricelistCaseReminderCaseSchema = z.object({
  id: z.string().uuid(),
  /** Rendered human-readable case number, e.g. "PC-1042". */
  caseNumber: z.string().nullable(),
  /** The vendor the price change came from. */
  companyName: z.string().nullable(),
  /**
   * The frozen waiting-on key the case is parked under, NOT a resolved label:
   * labels come from per-org module config and must never be snapshotted into
   * a persisted bundle.
   */
  waitingOnKey: z.string().nullable(),
  /**
   * ISO timestamp of the case's elapsed "Set next step" follow-up — the reason
   * it is in the reminder at all.
   */
  followUpDueAt: z.iso.datetime().nullable(),
});

/**
 * One recipient's reminder: the due follow-up cases assigned to them. A case
 * with no user assignee is never bundled — a reminder needs an owner with a
 * mailbox. The fan-out also lets each recipient be notified on their own
 * preferred channels.
 */
export const pricelistCaseReminderBundleSchema = z.object({
  recipientUserId: z.string().uuid().nullable(),
  recipientEmail: z.string().email().nullable(),
  caseCount: z.number().int().nonnegative(),
  cases: z.array(pricelistCaseReminderCaseSchema),
});

export const pricelistCaseFilesReadyCaseSchema = z.object({
  id: z.string().uuid(),
  caseNumber: z.string().nullable(),
  companyName: z.string().nullable(),
  filesReadyAt: z.string().date().nullable(),
});

export const pricelistCaseFilesReadyBundleSchema = z.object({
  recipientUserId: z.string().uuid(),
  caseCount: z.number().int().nonnegative(),
  cases: z.array(pricelistCaseFilesReadyCaseSchema),
});
